import React, { Component } from 'react';
import { detect } from 'detect-browser';
import LoadingOverlay from './SubComponents/LoadingOverlay/LoadingOverlay';
import BrowserSelection from './NewBrowserSelection/NewBrowserSelection';
import LocationSelection from './LocationSelection/LocationSelectionContainer';
import DateSelection from './DateSelection/DateSelectionContainer';
import SequenceSelection from './SequenceSelection/SequenceSelectionContainer';
import StationSelection from './StationSelection/StationSelectionContainer';
import PartyRoomSelection from './PartyRoomSelection/PartyRoomSelectionContainer';
import Checkout from './Checkout/CheckoutContainer';
import Pay from './Pay/PayContainer';
import { AppStep } from '../reducers/navigation';
import { isValidRoute } from '../routesMap';
import 'react-toastify/dist/ReactToastify.css';

const landscapeWidth = 720;
const browser = detect();

export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth
    };
  }

  componentDidMount() {
    if (!isValidRoute(this.props.currentPath)) this.props.goHome();
    this.setState({
      windowWidth: window.innerWidth
    });
    window.addEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    if (window.innerWidth !== this.state.windowWidth) {
      this.setState({
        windowWidth: window.innerWidth
      });
    }
  }

  switcher() {
    const { currentStep } = this.props.navigation;
    switch (currentStep) {
      case AppStep.Location:
        return <LocationSelection LocationId={this.props.location_id} />;
      case AppStep.Date:
        return <DateSelection />;
      case AppStep.Sequence:
        return <SequenceSelection />;
      case AppStep.Station:
        return <StationSelection landscape={this.state.windowWidth >= landscapeWidth} />;
      case AppStep.PartyRoom:
        return <PartyRoomSelection landscape={this.state.windowWidth >= landscapeWidth} />;
      case AppStep.Checkout:
        return <Checkout />;
      case AppStep.Pay:
        return <Pay />;
      default:
        return <div>ERROR</div>;
    }
  }

  render() {
    return (
      browser && browser.name !== 'ie' ?
        (
          <div className={'SizeDetector'} ref={x => { this.sizeDetectorRef = x; }}>
            <LoadingOverlay isOpen={this.props.loading} />
            {this.switcher()}
          </div>
        ) : (
          <div className={'SizeDetector'} ref={(x) => { this.sizeDetectorRef = x; }}>
            <LoadingOverlay isOpen={this.props.loading} />
            <BrowserSelection />
          </div>
        )
    );
  }
}
